export default __webpack_public_path__ + "20dcd286133fc6e10ba617eea7588dd2.png";